export const ADD_INPUT_BOX = "ADD_INPUT_BOX";
export const ADD_GROUP = "ADD_GROUP";
export const DELETE_INPUT_BOX = "DELETE_INPUT_BOX";
export const EDIT_INPUT_BOX = "EDIT_INPUT_BOX";
export const SHOW_FLASH_CARDS = "SHOW_FLASH_CARDS";
export const PROCESS_PDF = "PROCESS_PDF";
export const PDF_PROCESSING_ERROR = "PDF_PROCESSING_ERROR";
